export default {
  buttons: {
    cancel: "СКАСУВАННЯ",
    dismiss: "закрити",
    add_waypoint: "Додати пункт призначення"
  },
  distance: {
    value: "{distance, number, distance} {unit}",
    unit: {
      miles: "Милі"
    }
  },
  search: {
    title: "Пошук",
    placeholder: "Введіть Місцезнаходження",
    enter_location: "Введіть Місцезнаходження",
    help: {
      inactive: "Пошук"
    }
  },
  filters: {
    title: "фільтри",
    amenities: {
      title: "Послуги та Зручності"
    },
    fuels: {
      title: "Види палива"
    }
  },
  directions: {
    title: "планування маршруту",
    placeholder: {
      destination: "Введіть Місцезнаходження",
      waypoint: "Введіть Місцезнаходження"
    },
    route: {
      title: "варіанти маршруту",
      avoid_tolls: "Уникати платних доріг",
      avoid_highways: "Уникати автомагістралей",
      title_corridor: "Відстань від маршруту до заправної станції"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# день} other {# днів}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# хвилин} other {# хвилин}}\
`,
    button: "Пошук"
  },
  locations: {
    title: "Місцезнаходження",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} з {place}"
  },
  info_window: {
    title: "докладніше про станцію",
    services: "Послуги та Зручності",
    nearby: "довколишній",
    opening_hours: {
      title: "Час роботи",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      last_updated_on: "останнє оновлення",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "планування маршруту"
  },
  fuels: {
    autogas_lpg: "Power Gas",
    low_octane_gasoline: "A-92",
    midgrade_gasoline: "A-95",
    premium_diesel: "V-Power Nitro+ Diesel",
    premium_gasoline: "Shell V-Power Nitro+",
    shell_regular_diesel: "Diesel"
  },
  amenities: {
    air_and_water: "повітря",
    atm: "Банкомат",
    austrian_highway_sticker: "Австрійська наклейка",
    bank_note_acceptor: "Розрахунковий термінал",
    bottled_gas: "Обмін пропанових балонів",
    cafe: "кафетерій",
    carwash: "мийка",
    clubsmart_card: "Клубна карта",
    credit_card_american_express: "Кредитна картка - American Express",
    credit_card_diners_club: "Кредитна картка - Diners",
    credit_card_mastercard: "Кредитна картка - Mastercard",
    credit_card_visa: "Кредитна карта - Visa",
    credit_card: "кредитна карта",
    czech_highway_sticker: "Чеська наклейка",
    euroshell_card: "Shell Card",
    fleet_card_dkv: "фліт  карти - DKV",
    fleet_card_eni: "фліт  карти - Eni",
    fleet_card_esso: "фліт  карти - Esso",
    fleet_card_general: "фліт карти",
    fleet_card_uta: "фліт  карти - UTA",
    food_offerings: "Пропонуємо скоштувати",
    full_service: "Повний сервіс / Помічник із обслуговування",
    guarded_car_park: "стоянка, що охороняється",
    hgv_lane: "обслуговування вантажівок",
    high_speed_diesel_pump: "Високошвидкісний Дизель",
    hot_food: "гаряча їжа",
    hungarian_highway_sticker:
      "Угорська наклейка (highway sticker - наклейка на автомобиль, с написанным на ней кодом страны)",
    ido_ticket: "Ido квиткі",
    maut_terminal: "Maut термінал",
    parking_lanes: "паркувальна смуга",
    partner_loyalty_accepted: "Приймається картка клубу лояльності",
    pay_at_pump: "Оплата на станції",
    quick_lubes: "Quick-lube (заміна мастила)",
    restaurant: "Ресторан",
    self_service: "самообслуговування",
    service_bay: "бокси технічного обслуговування",
    shell_card: "Shell Card",
    shop: "магазин",
    shower: "душ",
    slovak_highway_sticker: "Словацька наклейка",
    snack_food: "Закуски / Фастфуд",
    standard_toilet: "туалет",
    supermarket_fuel_discount: "паливо зі знижками",
    toilet: "туалет",
    truck_parking: "вантажівка парковка",
    truckport: "тільки для вантажівок ",
    twenty_four_hour: "24 години",
    vacuum: "Пилосос",
    vehicle_identity_system: "Система ідентифікації автомобіля"
  },
  settings: {
    title: "налаштування",
    tooltip: "налаштування",
    distance_units: {
      title: "Відстань",
      km: "Кілометри",
      miles: "Милі"
    },
    language: {
      title: "мова"
    }
  }
}
